import { inject, Injectable } from '@angular/core';
import { ApiHelper, ApiService, HttpResponse, HttpStatusEnum } from '@core/api';

@Injectable({ providedIn: 'root' })
export class FileApi {
    private apiService = inject(ApiService);

    downloadFile(fileId: number): Promise<HttpResponse<any>> {
        return new Promise<HttpResponse<any>>(resolve => {
            this.apiService.download(`files/download-file?fileId=${fileId}`).subscribe({
                next: (res: any) => {
                    resolve({
                        isLoading: true,
                        status: HttpStatusEnum.SUCCESS,
                        data: res,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, err?.error?.message);
                    console.error(err);
                },
            });
        });
    }

    removeFile(fileId: number): Promise<HttpResponse<any>> {
        return new Promise<HttpResponse<any>>(resolve => {
            this.apiService.delete(`files/remove-file?fileId=${fileId}`).subscribe({
                next: (res: any) => {
                    resolve({
                        isLoading: true,
                        status: HttpStatusEnum.SUCCESS,
                        data: res,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, err?.error?.message);
                    console.error(err);
                },
            });
        });
    }
}
